// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/tabs-faqs/tabs-faqs.component.scss
// module id = 326
// module chunks = 0